import { useControl } from "../hooks";
import type { BaseFormProps } from "../types";
import { Input, type InputProps } from "./Input";

export type FormInputProps<T> = Omit<InputProps, "onClear"> &
	Omit<BaseFormProps, "error"> & {
		isClearable?: boolean;
		transform?: (value: string) => T;
	};

export const FormInput = <T extends string | number>({ transform, isClearable, ...props }: FormInputProps<T>) => {
	const { error, field } = useControl({ name: props.name });
	return (
		<Input
			{...props}
			error={error}
			{...field}
			onBlur={(e) => {
				field.onBlur();
				props.onBlur?.(e);
			}}
			value={transform ? transform(field.value) : (field.value ?? "")}
			onChange={(e) => {
				field.onChange({
					...e,
					target: {
						...e.target,
						value: transform ? transform(e.target.value) : e.target.value,
					},
				});
				props.onChange?.(e);
			}}
			onClear={
				isClearable
					? () => {
							field.onChange({
								target: { value: "" },
							} as React.ChangeEvent<HTMLInputElement>);
							props.onChange?.({
								target: { value: "" },
							} as React.ChangeEvent<HTMLInputElement>);
						}
					: undefined
			}
		/>
	);
};
